export default "__VITE_ASSET__0ffd3e06__"